import { render, staticRenderFns } from "./SpecialityItem.vue?vue&type=template&id=5c330596&scoped=true"
import script from "./SpecialityItem.vue?vue&type=script&lang=js"
export * from "./SpecialityItem.vue?vue&type=script&lang=js"
import style0 from "./SpecialityItem.vue?vue&type=style&index=0&id=5c330596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c330596",
  null
  
)

export default component.exports